import React, { useState, useEffect, useMemo } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Spinner } from "react-bootstrap";
import _ from "lodash";
import SupplierWithdrawal from "../../../../core/api/api.Withdrawal";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { NewWithdrawalsModal } from "./NewWithdrawalsModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";

const Withdrawals = () => {
  let location = useLocation();
  let navigate = useNavigate();
  const [listData, setListData] = useState({});
  const [refresh, setRefresh] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  };
  const [showModalWithdrawals, setShowModalWithdrawals] = useState(false);
  const [selectedWithdraw, setSelectedWithdraw] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const data = await SupplierWithdrawal.getAllUserWithdrawal({
          pageSize: getValues("pageSize"),
          pageNumber: getValues("pageNumber"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => {};
  }, [refresh]);

  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };

  const onSubmit = async (data) => {
    const apiData = await SupplierWithdrawal.getAllUserWithdrawal({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
  };

  async function handleGroupEdit() {}

  return (
    <div>
      {!_.isEmpty(location.state) && location.state?.newWithdrawals ? (
        <NewWithdrawalsModal callback={callBackJustForRunUseEffect} />
      ) : location?.pathname == "/supllierWithdrawals/0" ? (
        <NewWithdrawalsModal callback={callBackJustForRunUseEffect} />
      ) : (
        ""
      )}
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              درخواست های برداشت
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              {" "}
              لیست درخواست برداشت وجه توسط شما
            </span>
          </h3>
          <div className="card-toolbar">
            {/* <Link variant="success" className="btn btn-success"
                     key={0}
                     to={{
                         pathname: "/Withdrawals/0",
                         state: { newWithdrawals: true }
                     }}
                 >
                   
                        درخواست برداشت وجه
                      </Link> */}
            <Button
              variant="primary"
              onClick={() => {
                setSelectedWithdraw(0);
                setShowModalWithdrawals(true);
              }}
            >
              <AddCircle className="mr-1" />
              درخواست برداشت وجه
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <FormControl
                        type="text"
                        style={{ height: "40px" }}
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" variant="warning" size="sm" />
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  callback={callBackJustForRunUseEffect}
                  setShowModalWithdrawals={setShowModalWithdrawals}
                  setSelectedWithdraw={setSelectedWithdraw}
                />
              </Col>
            </form>
          </FormProvider>
          {showModalWithdrawals && (
            <NewWithdrawalsModal
              showModalWithdrawals={showModalWithdrawals}
              setShowModalWithdrawals={setShowModalWithdrawals}
              selectedWithdraw={selectedWithdraw}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Withdrawals;
